import CommonDialog from "@amplio-common/components/Dialog";

export default CommonDialog;

